import dynamic from 'next/dynamic';
import * as React from 'react';
import { ComponentType } from 'react';
import { Review } from 'schema-dts';

import { StaticComponent, StaticComponentOptions } from '@/lib/types';

import { testimonials } from '@/components/static/testimonials';

import { nomadHealthOrg, TSchemaData } from '@/services/schema-service';

const StaticComponentOptionsMap: Record<StaticComponentOptions, ComponentType> =
  {
    POPULAR_DESTINATIONS: dynamic(
      () => import('@/components/static/popular-destinations')
    ),
    TRAVEL_NURSING_JOBS_BY_STATE: dynamic(
      () => import('@/components/static/travel-nursing-jobs-by-state')
    ),
    TESTIMONIALS: dynamic(() => import('@/components/static/testimonials')),
    PRESS_LOGOS: dynamic(() => import('@/components/static/recent-press')),
    SEARCH_JOBS_BY_DISCIPLINE: dynamic(
      () => import('@/components/static/search-jobs-by-discipline')
    ),
    VACCINE_CARD_UPLOAD_FORM: dynamic(
      () => import('@/components/static/covid-vaccine-card-form')
    ),
    FACILITY_CONTACT_US_FORM: dynamic(
      () => import('@/components/static/facility-contact-us-form')
    ),
    WAITLIST_FORM: dynamic(() => import('@/components/static/waitlist-form')),
    TIMECARD_FORM: dynamic(() => import('@/components/static/timecard-form')),
  };

StaticComponentRenderer.buildSchema = buildSchema;

function buildSchema(component: StaticComponent): Partial<TSchemaData<Review>> {
  if (component.staticComponent !== 'TESTIMONIALS') return {};

  return {
    things: testimonials.map(({ name, message }) => ({
      '@context': 'https://schema.org',
      '@type': 'Review',
      name: `${name}'s review`,
      itemReviewed: nomadHealthOrg,
      author: { '@type': 'Person', name },
      reviewBody: message,
    })),
  };
}

export default function StaticComponentRenderer(props: StaticComponent) {
  const RenderStaticComponent =
    StaticComponentOptionsMap[props.staticComponent];
  return (
    <div>
      <RenderStaticComponent />
    </div>
  );
}
